'use client';

import { useEffect } from 'react';
import { startWebsiteSessionReplay } from './session-replay.service';

export default function WebsiteSessionReplay() {
  useEffect(() => startWebsiteSessionReplay(), []);

  return null;
}
